import { Box, Typography } from '@mui/material'
import React from 'react'
import { usePatientFormI18n } from '../utils/patientFormI18n'
import {
  PatientCard,
  PatientFieldHint,
  PatientFormField,
  PatientFormGrid,
  PatientRowDeleteButton,
  PatientTextInput,
} from './PatientFormPrimitives'

export const CommunicationReceiver = ({
  receiver = {},
  index,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
}) => {
  const { copy } = usePatientFormI18n()
  const {
    toEmail = '',
    toPhone = '',
    toWhatsAppId = '',
    toUserId = '',
    toPatientId = '',
  } = receiver

  const validation = validationHook?.getCommunicationReceiverValidation?.(index)
  const hasError = Boolean(validation?.showError)
  const disabled = !editMode

  const handleFieldChange = (field, value) => {
    if (editMode && onUpdate) {
      onUpdate(index, field, value)
    }
  }

  const idBase = `patient-receiver-${index}`
  const fields = [
    { key: 'toEmail', label: copy.recipientEmailLabel, placeholder: copy.recipientEmailPlaceholder, value: toEmail, type: 'email', span: { xs: 12, md: 6 } },
    { key: 'toPhone', label: copy.recipientPhoneLabel, placeholder: copy.recipientPhonePlaceholder, value: toPhone, type: 'tel', span: { xs: 12, md: 6 } },
    { key: 'toWhatsAppId', label: copy.recipientWhatsappLabel, placeholder: copy.recipientWhatsappPlaceholder, value: toWhatsAppId, type: 'text', span: { xs: 12, md: 6 } },
    { key: 'toUserId', label: copy.recipientUserIdLabel, placeholder: copy.recipientUserIdPlaceholder, value: toUserId, type: 'text', span: { xs: 12, md: 6 } },
    { key: 'toPatientId', label: copy.recipientPatientIdLabel, placeholder: copy.recipientPatientIdPlaceholder, value: toPatientId, type: 'text', span: 12 },
  ]

  return (
    <PatientCard>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          marginBottom: '10px',
        }}
      >
        <Typography component="div" sx={{ fontSize: '13px', fontWeight: 700, color: '#334155' }}>
          {copy.recipientTitle(index)}
        </Typography>
        {!disabled && (
          <PatientRowDeleteButton
            label={copy.removeLabel}
            onClick={() => {
              if (onRemove) onRemove(index)
            }}
          />
        )}
      </Box>

      <PatientFormGrid sx={{ rowGap: '10px' }}>
        {fields.map((field) => (
          <PatientFormField
            key={field.key}
            label={field.label}
            span={field.span}
            htmlFor={`${idBase}-${field.key}`}
          >
            <PatientTextInput
              id={`${idBase}-${field.key}`}
              type={field.type}
              value={field.value}
              placeholder={field.placeholder}
              disabled={disabled}
              invalid={hasError}
              onChange={(event) => handleFieldChange(field.key, event.target.value)}
            />
          </PatientFormField>
        ))}
      </PatientFormGrid>

      {hasError ? (
        <PatientFieldHint tone="error" sx={{ marginTop: '8px' }}>
          {validation.errorMessage || copy.recipientValidation}
        </PatientFieldHint>
      ) : (
        <PatientFieldHint sx={{ marginTop: '8px' }}>{copy.recipientHelper}</PatientFieldHint>
      )}
    </PatientCard>
  )
}

export default CommunicationReceiver
